import { Box } from '@locus-taxy/disco-ui';
import LoadingSpinner from './LoadingSpinner';

interface SuspenseLoaderProps {
  message?: string;
}

const SuspenseLoader = ({ message }: SuspenseLoaderProps) => {
  return (
    <Box className="flex h-screen items-center justify-center">
      <LoadingSpinner showRandomMessage={false} message={message} />
    </Box>
  );
};

export default SuspenseLoader;
